export class Warehouse {
  public id?: string = '';
  public warehouseCompanyId?: string = '';
  public warehouseCompanyName?: string = '';
  public name?: string = '';
  public note?: string = '';
  // Contact
  public picName?: string = '';
  public phoneNumber?: string = '';
  public postalCode?: string = '';
  public address1?: string = '';
  public address2?: string = '';
  // Account
  public accountId?: string = '';
  public accountUsername?: string = '';
  public accountEmail?: string = '';
  public accountPassword?: string = '';

  constructor(init?: Partial<Warehouse>) {
    Object.assign(this, init);
  }
}
